export enum MenuTypes{
    Vertical = 'vertical',
    Horizontal = 'horizontal'
}